import { lazy } from 'react';
export const AdaChatIcons = {
  chat: lazy(() => import('./chat-icon')),
  chatMobile: lazy(() => import('./chat-mobile-icon'))
};
export const AdaNetspendChatIcons = {
  chatNetspend: lazy(() => import('./chat-netspend-icon'))
};